class ModuleType {

	get SLIDER_VIDEO() { return 'sliderVideo'; }
	get SLIDER_IMAGE() { return 'sliderVideo'; }
	get VIDEO() { return 'video'; }

}

export default new ModuleType();
